





























import { defineComponent, PropType, computed } from '@nuxtjs/composition-api';
import AppRectButton from '~/components/partials/App/AppRectButton.vue';
import { useRuntimeConfig } from '~/composables/useRuntimeConfig';
import { DynamicPartsTwoColumnButton } from '~/types/modules/contents';

export default defineComponent({
  components: {
    AppRectButton,
  },
  props: {
    item: {
      type: Object as PropType<DynamicPartsTwoColumnButton>,
      required: true,
    },
  },
  setup(props) {
    const { FRONTEND_ORIGIN } = useRuntimeConfig();

    // 内部かどうか
    const isSameOriginLeftUrl = computed((): boolean => {
      return !!props.item.left_button.url?.includes(FRONTEND_ORIGIN);
    });

    // 内部かどうか
    const isSameOriginRightUrl = computed((): boolean => {
      return !!props.item.right_button.url?.includes(FRONTEND_ORIGIN);
    });

    const splitLeftText = computed(() => {
      // 15文字で改行する
      return [props.item.left_button.text.slice(0, 15), props.item.left_button.text.slice(15)].filter((text) => !!text);
    });

    const splitRightText = computed(() => {
      // 15文字で改行する
      return [props.item.right_button.text.slice(0, 15), props.item.right_button.text.slice(15)].filter(
        (text) => !!text
      );
    });

    return {
      isSameOriginLeftUrl,
      isSameOriginRightUrl,
      splitLeftText,
      splitRightText,
    };
  },
});
